export default {"src":"https://fishbrain.com/_next/static/media/apple_app_store.bbfeaae5.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};